import { renderTextLineClamp } from 'helpers';
import { OrdersListItem } from 'modules/order/orders/types';

export const renderClient = (item: OrdersListItem) =>
  renderTextLineClamp(item.client.fullName);
